import styled from 'styled-components';
import { NavLink as ReactNavLink } from 'react-router-dom';

export const Container = styled.aside`
  background: #f8fafc;
  position: fixed;
  top: 0;
  left: 0;
  width: 168px;
  height: 100vh;
  padding: 0 0 16px;
  border-right: 1px solid #e2e8f0;

  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 10;
  overflow-y: auto;
  overscroll-behavior: contain;
`;

export const Logo = styled.img`
  padding: 20px 16px;
  max-width: 100%;
  margin: 0 auto 8px;
  display: block;
  transition: transform 0.25s ease;

  &:hover {
    transform: scale(1.04);
  }
`;

export const LogoDivider = styled.div`
  height: 1px;
  margin: 0 16px 12px;
  background: linear-gradient(
    90deg,
    rgba(226, 232, 240, 0) 0%,
    #e2e8f0 50%,
    rgba(226, 232, 240, 0) 100%
  );
`;

export const NavLink = styled(ReactNavLink)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 4px 12px 0;
  padding: 12px 10px;
  border-radius: 12px;
  color: #475569;
  font-size: 0.78rem;
  font-weight: 500;
  text-align: center;
  letter-spacing: -0.01em;
  transition: all 0.2s ease;
  position: relative;

  svg {
    color: #64748b;
    transition: color 0.2s ease, transform 0.2s ease;
  }

  &:hover {
    background: #f1f5f9;
    color: #0f172a;
    text-decoration: none;

    svg {
      color: #0f172a;
      transform: translateY(-1px);
    }
  }

  &.active {
    background: #006633;
    color: #ffffff;
    box-shadow: 0 6px 16px rgba(0, 102, 51, 0.25);

    svg {
      color: #ffffff;
    }

    &:hover {
      background: #006633;
      color: #ffffff;
    }
  }
`;
